import { createGlobalStyle } from 'styled-components';
export const Styles = createGlobalStyle`
.footer {
  min-height:6rem; 
  box-shadow: 0rem -1rem 0rem var(--mercer-gray-300-dadada-);
  background: #FAFAFA ;
  box-shadow: 0rem -0.062rem 0rem #DADADA;
  background-color:  #FAFAFA
  opacity: 1;
  background-color:  ${({ theme }) =>
  theme.components && theme.components.footer && theme.components.footer.footerBgColor};
  background-color:  #FAFAFA
}

.footer .clientLogo  {
  cursor: pointer;
  max-width: 8rem;
  height: auto;
  max-height: 2.5rem;
  vertical-align: middle;
  object-fit: contain;
}

.footer .list-items  {
  &:after{
    content: '|'; 
    background: var(--mercer-gray-400-b3b3b3-) 0% 0% no-repeat padding-box;
  }
  vertical-align: sub;
  color: #002C77;
  text-align: left;
  letter-spacing: 0rem;
  opacity: 1;
  font-style: normal;
  font-weight: normal;
  font-size:0.875rem;
  font-family:  NotoSansRegular; 
  color: ${({ theme }) =>
  theme.components && theme.components.footer && theme.components.footer.footerLinkFontColor};
}

.footer .list-items-last  {
  vertical-align: sub;
  color: #002C77;
  text-align: left;
  letter-spacing: 0rem;
  opacity: 1;
  font-style: normal;
  font-weight: normal;
  font-size:0.875rem;
  font-family:  NotoSansRegular; 
  color: ${({ theme }) =>
  theme.components && theme.components.footer && theme.components.footer.footerLinkFontColor};
}

.copyright {
  background-color:  #FAFAFA
  text-align: right;
  letter-spacing: 0rem;
  color: #4F4F4F;
  opacity: 1;
  font-style: normal;
  font-weight: normal;
  font-size:0.8rem;
  line-spacing: 1rem;
  font-family:  NotoSansRegular;
  background-color:${({ theme }) =>
  theme.components && theme.components.footer && theme.components.footer.footerBgColor};
  color:${({ theme }) =>
  theme.components &&
  theme.components.footer &&
  theme.components.footer.footerCopyrightFontColor};
}
.span {
  color: #002C77; 
  cursor: pointer;
}

.span:hover {
  color: #444444; 
  text-decoration: underline;
}

.footerClass .container-fluid{
  padding-right: 6rem!important;
}

/* Extra small devices (mobile) */
@media only screen and (max-width: 576px) {
  .footer {
    min-height: auto;
    padding: 0.75rem 0;
  }
  
  .footerClass .container-fluid {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  
  .footer .clientLogo {
    max-width: 6rem !important;
    max-height: 2rem !important;
    width: auto;
    display: block;
  }
  
  .copyright {
    font-size: 0.625rem !important;
    padding-top: 0.25rem;
    text-align: center !important;
  }
  
  .divLinks {
    justify-content: center !important;
    font-size: 0.75rem;
  }
  
  .footer .list-items,
  .footer .list-items-last {
    font-size: 0.75rem;
  }
  
  .sec-row {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

/* Small devices (landscape phones, 577px - 767px) */
@media only screen and (min-width: 577px) and (max-width: 767px) {
  .footerClass .container-fluid {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  
  .footer .clientLogo {
    max-width: 7rem;
    vertical-align: middle;
  }
  
  .copyright {
    font-size: 0.7rem;
    text-align: center;
  }
  
  .divLinks {
    justify-content: center !important;
  }
  
  .sec-row {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

@media only screen and (max-width: 767px) { 
  .footer .clientLogo  {
    vertical-align: middle;
  }
}

 /* Tablet devices (768px and up) */
 @media only screen and (min-width: 768px) {
  .copyright {
    font-size: 0.75rem;
  }
  .divLinks {
    justify-content: end!important;
  }
  .sec-row {
    padding-top: 1.5rem;
  }
 }

 /* Desktop devices ( 1366px and up) */
 @media only screen and (min-width: 1366px) {
  .copyright {
    font-size: 0.75rem;
  }
  .divLinks {
    justify-content: end!important;
  }
  .sec-row {
    padding-top: 1.25rem;
  }
 }
`;
